import Accordion from 'accordion-js';
import { refs } from './refs';
import { BASE } from './config';

const faqData = [
  {
    q: 'Я мрію про пухнастика! Що мені потрібно зробити, щоб забрати хвостика додому?',
    blocks: [
      {
        type: 'p',
        text: "Це чудово, що ви готові подарувати дім одному з наших підопічних! Ми дуже раді будемо вам у цьому допомогти. Процес «усиновлення» у нас простий та зрозумілий:",
      },
      {
        type: 'ol',
        items: [
          "Оберіть друга: Придивіться до наших хвостиків у розділі «Знайди друга».",
          "Залиште заявку: Коли відчуєте, що це «ваша» тваринка, натискайте кнопку «Взяти додому» та заповніть коротку анкету.",
          "Поговоріть з куратором: Наш волонтер зателефонує вам, щоб познайомитись ближче, розповісти про характер тваринки та відповісти на всі ваші питання.",
          "Приїжджайте знайомитись: Якщо ви ідеально підходите одне одному, ми домовимось про зустріч у притулку.",
          "Дорога додому: Після знайомства та підписання договору про відповідальне утримання, ваш новий друг поїде з вами у своє нове, щасливе життя!",
        ],
      },
    ]
  },
  {
    q: "Як мені найкраще підготувати свій дім та родину до появи хвостика?",
    blocks: [
      {
        type: 'p',
        text: "Чудове питання, яке показує вашу турботу! Переїзд — це завжди невеликий стрес для тваринки, але правильна підготовка зробить цей процес легким і радісним. Ось кілька порад:",
      },
      {
        type: 'ul',
        items: [
          "Безпечний простір: Переконайтесь, що на вікнах є сітки, а дроти та побутова хімія сховані.",
          "Особисті речі: Підготуйте для хвостика дві мисочки (для їжі та води), лежанку чи будиночок, лоток з наповнювачем для котика або повідець і нашийник для собачки.",
          "Сімейна розмова: Обговоріть з рідними майбутні обов'язки. Важливо, щоб усі були готові до появи нового мешканця.",
          "Терпіння та любов: Дайте тваринці час, щоб звикнути. Не квапте її, будьте поруч, розмовляйте лагідним голосом — і ваша любов творитиме дива!",
        ],
      },
    ]
  },
  {
    q: "Чи можу я бути впевненим, що тваринка здорова? Розкажіть про щеплення.",
    blocks: [
      {
        type: 'p',
        text: "Так, звісно. Здоров'я наших підопічних — наш головний пріоритет. Кожна тваринка, яка потрапляє до нас, проходить повний огляд у ветеринара. Ми гарантуємо, що:",
      },
      {
        type: 'ul',
        items: [
          "Усі хвостики оброблені від бліх та глистів.",
          "Усі вакциновані комплексною вакциною за віком.",
          "Дорослі тварини (зазвичай від 6-8 місяців) стерилізовані/кастровані.",
        ],
      },
      {
        type: 'p',
        text:
          "Разом із тваринкою ви обов'язково отримаєте її ветеринарний паспорт з усіма відмітками. Якщо у когось є особливі потреби у догляді чи харчуванні, ми чесно і детально про це розповімо.",
      },
    ]
  },
  {
    q: "Я дуже хочу допомогти, але поки не готовий до адопції. Чим я можу підтримати «Хатинку лапок»?",
    blocks: [
      {
        type: 'p',
        text: "Дякуємо вам за велике серце та бажання допомогти! Кожна допомога для нас безцінна. Навіть якщо ви не можете взяти тваринку, ви можете стати її янголом-охоронцем. Ось як:",
      },
      {
        type: 'ul',
        items: [
          "Допомогти фінансово: Ваша пожертва піде на корм, ліки, оплату комунальних послуг та зарплату персоналу.",
          "Стати волонтером: Нам завжди потрібні люблячі руки для прогулянок з собачками, прибирання та, найголовніше, для спілкування з тваринками.",
          "Подарувати необхідне: Ми завжди раді кормам, лікам, наповнювачам для лотків, іграшкам, теплим ковдрам.",
          "Допомогти інформаційно: Найпростіший, але дуже дієвий спосіб — розповідати про нас у соцмережах. Можливо, саме ваш репост допоможе комусь знайти свою долю!",
        ],
      },
    ]
  },
  {
    q:  "Мені сподобалась одна з ваших тваринок на сайті. Чи можу я приїхати, щоб познайомитися з нею особисто?",
    blocks: [
      {
        type: 'ul',
        items: [
          "Авжеж! Ми віримо, що справжня магія стається лише при особистій зустрічі. Щоб знайомство було комфортним і для вас, і для тваринки, ми просимо вас спочатку заповнити онлайн-заявку на нашому сайті.",
          "Після цього з вами зв'яжеться куратор тваринки, щоб домовитись про зручний час для вашого візиту. Такий підхід дозволяє нам приділити вам максимум уваги та уникнути зайвого стресу для наших підопічних. З нетерпінням чекаємо на знайомство!",
        ],
      },
    ],
  }
];

const renderBlock = block => {
  if (block.type === 'p') {
    return `<p>${block.text}</p>`;
  }

  if (block.type === 'ol' || block.type === 'ul') {
    const items = block.items ?? [];
    const itemsHtml = items.map(text => `<li>${text}</li>`).join('');
    return `<${block.type}>${itemsHtml}</${block.type}>`;
  }

  return '';
};

const renderFaqItem = ({ q, blocks = [] }) => `
  <li class="ac">
    <h3 class="ac-header">
      <button class="ac-trigger" type="button" aria-label="Питання">
        <span class="faq-question">${q}</span>
        <span class="faq-icon">
          <svg aria-hidden="true" width="24" height="24">
            <use href="${BASE}sprite.svg#icon-add"></use>
          </svg>
        </span>
      </button>
    </h3>

    <div class="ac-panel" role="region" aria-labelledby="Питання">
      <div class="faq-content">
        ${blocks.map(renderBlock).join('')}
      </div>
    </div>
  </li>
`;

refs.faqListEl.innerHTML = faqData.map(renderFaqItem).join('');

new Accordion('.accordion-container', {
  duration: 1000,
  showMultiple: false,
  collapse: true,
  ariaEnabled: true,
});


const faqAnim = document.querySelector('.faq-ajax-loader');
const total = 20;

for (let i = 0; i < total; i++) {
  const paw = document.createElement('div');
  paw.classList.add('paw');

  paw.style.animationDelay = `${(total - i) * 0.25 + 5}s`;

  const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  svg.classList.add('icon');

  const use = document.createElementNS('http://www.w3.org/2000/svg', 'use');
  use.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', '#paw1');

  svg.appendChild(use);
  paw.appendChild(svg);
  faqAnim.appendChild(paw);
}
